import { Component, OnInit, Input } from '@angular/core';
import { TaskAssignObject } from 'src/app/models/tasks/task/task-assign-object.model';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';

@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.component.html',
  styleUrls: ['./task-detail.component.css']
})
export class TaskDetailComponent implements OnInit {

  @Input() isBillingTask: boolean;
  @Input() taskDetails: TaskDetailsObject;
  @Input() currentAssignTask: TaskAssignObject;

  constructor() {
  }

  ngOnInit() {
  }

}
